export default {
  VITE_API_URL: import.meta.env.VITE_API_URL,
  VITE_WS_API_URL: import.meta.env.VITE_WS_API_URL,
  VITE_MUI_LICENSE: import.meta.env.VITE_MUI_LICENSE,
  VITE_RESOURCE_INSTRUCTION: import.meta.env.VITE_RESOURCE_INSTRUCTION,
  VITE_RESOURCE_SUPPORT: import.meta.env.VITE_RESOURCE_SUPPORT,
  VITE_FEATURE_LIGHT_DARK_MODE: import.meta.env.VITE_FEATURE_LIGHT_DARK_MODE,
  VITE_FEATURE_FLAG_SWITCHER: import.meta.env.VITE_FEATURE_FLAG_SWITCHER,
  VITE_FEATURE_HOUSEHOLD_REDIRECT: import.meta.env
    .VITE_FEATURE_HOUSEHOLD_REDIRECT,
  VITE_SUPPLY_SYSTEM_FINANCE_URL: import.meta.env
    .VITE_SUPPLY_SYSTEM_FINANCE_URL,
  VITE_CRM_URL: import.meta.env.VITE_CRM_URL,
  VITE_ADMIN_URL: import.meta.env.VITE_ADMIN_URL,
  // The «Gasbi AI» chat (ADR-0004 of Gasbi.Agents): its origin serves launcher.js; empty = no chat button.
  VITE_AGENTS_CHAT_URL: import.meta.env.VITE_AGENTS_CHAT_URL,
};
